import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ChatBubble",
  "use": "ChatBubble-usage",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ChatBubble\">\n<path d=\"M9 0H1C0.45 0 0 0.45 0 1V10L2 8H9C9.55 8 10 7.55 10 7V1C10 0.45 9.55 0 9 0Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol